
import "/Users/yingben001/IdeaProjects/edatlink-box-admin/src/pages/ISWAN_APP/layout/layout.less?modules";
export default {"main": `main-q-5OYxFe`,"navbar": `navbar-zyLKbnE2`,"body": `body-h9K7c1YU`}
